import {
  CREATE_DEAL,
  CREATE_DEAL_SUCCESS,
  CREATE_DEAL_FAILURE,
  EDIT_DEAL,
  EDIT_DEAL_SUCCESS,
  EDIT_DEAL_FAILURE,
  FORM_RESET,
  UPDATE_FIELD_DATA
} from './DealForm.actions'

const initialState = {
  isLoading: false,
  dealData: {},
  errors: [],
  requestComplete: false
}

const currentState = (state = initialState, action) => {
  switch(action.type) {
    case CREATE_DEAL:
    case EDIT_DEAL:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_DEAL_SUCCESS:
    case EDIT_DEAL_SUCCESS:
      return {
        ...state,
        errors: [],
        isLoading: false,
        requestComplete: true
      }
    case CREATE_DEAL_FAILURE:
    case EDIT_DEAL_FAILURE:
      return {
        ...state,
        isLoading: false,
        errors: action.payload
      }
    case FORM_RESET:
      return {
        ...state,
        isLoading: false,
        dealData: {},
        errors: [],
        requestComplete: false
      }
    case UPDATE_FIELD_DATA:
      return {
        ...state,
        dealData: action.payload
      }
    default:
      return state
  }
}

export default currentState;